up.$compiler('.selectpicker', ($element) => {
    $element.selectpicker();
})

up.compiler('.bs-searchbox input', (element) => {
    element.setAttribute('placeholder', 'Suchen...')
})